import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Navbar from './Components/navbar/Navbar';
import Header from './Components/header/Header';
import OurClient from './Components/ourclients/Ourclient';
import Servicesection from './Components/servicessection/Servicesection';
import Whychoose from './Components/whychoose/Whychoose';
import Testimonial from './Components/testimonial/Testimonial';
import Footer from './Components/footer/Footer';
import Aboutus from './Components/aboutus/Aboutus';
import Contact from './Components/contactus/Contact';
import Mainservices from './Components/servicessection/Mainservices';
import Webdevelopment from './Components/webdevelopment/Webdevelopment';
import Project from './Components/project/Project';
import FAQ from './Components/faq/FAQ';
import Software from './Components/webdevelopment/Softwate';
import Softwaretesting from './Components/webdevelopment/Software Testing';
import SEO from './Components/webdevelopment/SEO';
import Webmaintance from './Components/webdevelopment/WebMaintance';
import Ecommerce from './Components/webdevelopment/Ecommerce';
import Digitalmareting from './Components/webdevelopment/DigitalMarketing';
import Logodesign from './Components/webdevelopment/Logodesign';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <OurClient />
              <Servicesection />
              <Whychoose />
              <Project />
              <Testimonial />

            </>
          }
        />
        <Route path="/aboutus" element={<Aboutus />} />

        <Route path='/contactus' element={<Contact />} />
        <Route path='/service' element={<Mainservices />} />

        <Route path='/webdevelopment' element={<Webdevelopment />} />
        <Route path='/software' element={<Software />} />
        <Route path='/testing' element={<Softwaretesting />} />
        <Route path='/seo' element={<SEO />} />
        <Route path='/webmaintance' element={<Webmaintance />} />
        <Route path="/ecommerce" element={<Ecommerce />} />
        <Route path='/digitalmarketing' element={<Digitalmareting />} />
        <Route path='/logo' element={<Logodesign />} />


        <Route path="/faq" element={<FAQ />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
